import axios from "axios";

import type { TeamApplication } from "@virtual-brain-lib/types";

import env from "../environments";
import { queryOptions } from "../query-client/queryOption";

export const getTeamsApplicationsByApplicationId = queryOptions({
	queryKey: "teamsApplications",
	async queryFn({ queryKey }) {
		const [_, params] = queryKey;
		const response = await axios.get<TeamApplication[]>(
			`${env.apiUrl}/teams-applications/${params.applicationId}`,
		);

		return response.data;
	},
});

export const createTeamsApplication = async (teamsApplication: Partial<TeamApplication>) => {
	const response = await axios.post<TeamApplication>(
		`${env.apiUrl}/teams-applications`,
		teamsApplication,
	);

	return response.data;
};

export const deleteTeamsApplicationById = async (teamsApplicationId: string) => {
	await axios.delete(`${env.apiUrl}/teams-applications/${teamsApplicationId}`);

	return teamsApplicationId;
};
